import { create } from 'zustand';

const useRestoreScrollPositionStore = create((set,get) => ({
  scrollPositions: {},
  setScrollPosition: (url,newScrollPosition) => set((state) => ({
      scrollPositions: {
        ...state.scrollPositions,
        [url]: newScrollPosition
      }
    })),
    getPosition: (url) => get().scrollPositions[url] || 0,
}));

export default useRestoreScrollPositionStore;

